import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext'; // Adjust path as neededd
import Loader from '../Common/Loader'; // Adjust path as needed

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, isPasswordRecovery, user, session } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Loader />
      </div>
    );
  }

  // Handle password recovery sessions
  if (isPasswordRecovery && user && session) {
    // If user is in password recovery mode, only allow access to reset-password page
    if (location.pathname !== '/reset-password') {
      return <Navigate to="/reset-password" replace />;
    }
    // Allow access to reset-password page during recovery
    return children;
  }

  // Regular authentication check
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Don't allow access to reset-password page for regular authenticated users
  if (location.pathname === '/reset-password' && !isPasswordRecovery) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

// Component for routes that should only be accessible to non-authenticated users
function PublicRoute({ children }) {
  const { isAuthenticated, loading, isPasswordRecovery } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Loader />
      </div>
    );
  }

  // If user is in password recovery, redirect to reset-password
  if (isPasswordRecovery) {
    return <Navigate to="/reset-password" replace />;
  }

  // If user is authenticated, redirect to dashboard
  if (isAuthenticated) {
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return children;
}

export { ProtectedRoute, PublicRoute };
